// extracted by mini-css-extract-plugin
export default {"root":"page-overlay-menu_root__2FtZh","isOpen":"page-overlay-menu_isOpen__VfHD2"};